import { createContext, useContext, useEffect, useState } from "react";

export const CONTACT = {
  company: "Arte E Infissi Srls",
  phone: "328 177 7470",
  whatsapp: "393281777470",
  email: "arteeinfissi@gmail.com",
  hq_label_it: "Sede",
  hq: "Via Napoli 68, 00055 Ladispoli (RM)",
  factory_label_it: "Produzione & Showroom",
  factory: "Via Aurelia Km 41,600, 00052 Cerveteri (RM)",
  instagram: "https://www.instagram.com/arte_e_infissi_/",
  facebook: "https://www.facebook.com/arteeinfissi/",
  mapLat: 41.9507616,
  mapLng: 12.0809896,
  coordinates: "41.9508° N, 12.0810° E",
};

export const whatsappLink = (text) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text || "Buongiorno, vorrei richiedere un preventivo.")}`;

export const MARQUEE_ITEMS = [
  "2000+ CLIENTI SODDISFATTI",
  "DAL 2010 — CERVETERI, ROMA",
  "INFISSI SU MISURA IN ALLUMINIO, ALLUMINIO/LEGNO E PVC",
  "VETRATE PANORAMICHE A PACCHETTO",
  "PERGOTENDE ADDOSSATE E AUTOPORTANTI",
  "NUOVISSIMO IMPIANTO PVC",
  "LAVORARE CON PASSIONE",
];

export const MANIFESTO = [
  {
    number: "01",
    title_it: "Eleganza — L'impatto visivo ridotto al minimo",
    title_en: "Elegance — Visual impact reduced to the minimum",
    content_it: "Sistemi progettati per scomparire: pannelli, chiusure, binari e viti sono invisibili. Il risultato è una linea pulita che trasforma terrazzi, attici, balconi e verande in spazi luminosi e raffinati.",
    content_en: "Systems designed to disappear: panels, locks, tracks and screws are invisible. The result is a clean line that turns terraces, penthouses, balconies and verandas into bright, refined spaces.",
  },
  {
    number: "02",
    title_it: "Protezione — Vetro temperato e chiusure avanzate",
    title_en: "Protection — Tempered glass and advanced locking",
    content_it: "Sicurezza garantita dal vetro temprato da 10 mm e da sistemi di chiusura tecnologici. Accolgono luce e calore, ma bloccano pioggia, vento, polvere e insetti.",
    content_en: "Safety guaranteed by 10 mm tempered glass and technological locking systems. They welcome light and warmth, but keep out rain, wind, dust and insects.",
  },
  {
    number: "03",
    title_it: "Luce e calore — Vivere gli spazi tutto l'anno",
    title_en: "Light and warmth — Living your spaces all year round",
    content_it: "La luce del sole, i colori del cielo e del panorama entrano in casa. Veranda, giardino o dehors della tua attività diventano luoghi di comfort e benessere in ogni stagione.",
    content_en: "Sunlight, the colours of the sky and the landscape come indoors. Your veranda, garden or restaurant terrace becomes a place of comfort and wellbeing in every season.",
  },
  {
    number: "04",
    title_it: "Su misura — Dal rilievo alla posa",
    title_en: "Bespoke — From survey to installation",
    content_it: "Dal 2010 produciamo ogni infisso su misura nel nostro stabilimento di Cerveteri: rilievo in cantiere, progettazione, produzione e posa con squadre interne. Sostituzioni in ristrutturazione e forniture complete per nuove costruzioni.",
    content_en: "Since 2010 we have manufactured every frame to measure in our Cerveteri plant: on-site survey, design, production and installation by our own teams. Replacements in renovations and complete supplies for new builds.",
  },
];

const translations = {
  it: {
    nav_products: "Prodotti",
    nav_railings: "Balaustre in Vetro",
    filter_railings: "Balaustre in Vetro",
    nav_projects: "Progetti",
    nav_about: "Azienda",
    nav_contact: "Contatti",
    nav_admin: "Area Riservata",
    nav_quote: "Preventivo",
    hero_eyebrow: "Arte & Infissi — Cerveteri, Roma · Dal 2010",
    hero_line1: "Il confine",
    hero_line2: "tra dentro e fuori",
    hero_line3: "non esiste più.",
    hero_sub: "Infissi in alluminio, alluminio/legno e PVC, vetrate panoramiche e pergotende. Progettati, prodotti e installati su misura per la tua casa o la tua attività.",
    hero_cta_projects: "Scopri i Progetti",
    hero_cta_contact: "Richiedi un Preventivo",
    scroll_hint: "Scorri",
    intro_eyebrow: "Chi siamo",
    intro_title: "Dal 2010 produciamo infissi su misura per ogni esigenza. Oltre 2000 clienti ci hanno affidato la luce delle loro case.",
    products_eyebrow: "Prodotti",
    products_title: "Quattro sistemi, un'unica qualità",
    products_sub: "Dal design moderno alle elevate prestazioni isolanti: materiali selezionati per garantire durata, efficienza e stile.",
    products_all: "Tutti i prodotti",
    product_discover: "Scopri",
    featured_eyebrow: "Realizzazioni",
    featured_title: "Progetti in evidenza",
    view_all: "Tutti i progetti",
    ba_eyebrow: "Prima / Dopo",
    ba_title: "Lo stesso spazio. Una nuova vita.",
    ba_sub: "Trascina il cursore per vedere come una vetrata panoramica trasforma un balcone o una veranda in un ambiente vivibile tutto l'anno.",
    ba_before: "Prima",
    ba_after: "Dopo",
    ba_view_project: "Vedi il progetto",
    stats_eyebrow: "In numeri",
    stats_clients: "Clienti soddisfatti",
    stats_years: "Anni di esperienza",
    stats_since: "Anno di fondazione",
    stats_bespoke: "Su misura",
    manifesto_eyebrow: "Perché sceglierci",
    manifesto_title: "Quattro ragioni per affidarti alla nostra esperienza",
    contact_band_eyebrow: "Parliamone",
    contact_band_title: "Puoi affidarti alla nostra esperienza per i tuoi progetti.",
    contact_band_cta: "Scrivici su WhatsApp",
    contact_band_cta2: "Vai ai contatti",
    projects_eyebrow: "Portfolio",
    projects_title: "Opere & Realizzazioni",
    projects_sub: "Una selezione di vetrate, pergole, infissi e chiusure realizzate su misura per abitazioni private e attività commerciali nel Lazio.",
    filter_all: "Tutti",
    filter_windows: "Finestre",
    filter_doors: "Porte",
    filter_facades: "Facciate",
    filter_outdoor: "Vetrate & Pergole",
    filter_awnings: "Tende da Sole",
    filter_corten: "Cor-Ten & Bronzo",
    empty_title: "Il portfolio è in preparazione",
    empty_sub: "Nuove realizzazioni saranno pubblicate a breve.",
    back_to_projects: "Torna ai progetti",
    label_location: "Luogo",
    label_year: "Anno",
    label_architect: "Progetto",
    label_dimensions: "Dimensioni",
    label_materials: "Materiali",
    specs_title: "Prestazioni Tecniche",
    downloads_title: "Documentazione Tecnica",
    downloads_sub: "Schede tecniche, dettagli esecutivi DWG e schede materiale per il tuo studio.",
    downloads_placeholder_title: "Documentazione tecnica in preparazione",
    downloads_placeholder_sub: "Le schede tecniche PDF e i dettagli DWG di questo progetto saranno disponibili per il download a breve. Nel frattempo puoi richiederli direttamente.",
    downloads_placeholder_cta: "Richiedi la scheda tecnica",
    gallery_title: "Galleria",
    next_project: "Progetto successivo",
    download: "Scarica",
    gate_title: "Documentazione Tecnica",
    gate_sub: "Lascia i tuoi riferimenti professionali per scaricare il file richiesto.",
    gate_name: "Nome e cognome",
    gate_firm: "Studio / Società",
    gate_email: "Email professionale",
    gate_submit: "Scarica il file",
    gate_note: "Nessuna newsletter. Solo il file richiesto.",
    gate_success: "Download avviato. Grazie.",
    product_intro_eyebrow: "Il sistema",
    product_benefits_eyebrow: "Vantaggi",
    product_variants_eyebrow: "Soluzioni",
    product_specs_eyebrow: "Scheda tecnica",
    product_specs_note: "Valori indicativi. La scheda tecnica ufficiale sarà disponibile per il download.",
    product_datasheet_title: "Scheda tecnica PDF in arrivo",
    product_datasheet_sub: "La documentazione tecnica completa di questo sistema sarà caricata a breve. Richiedila subito su WhatsApp.",
    product_related: "Realizzazioni con questo sistema",
    product_cta: "Richiedi un preventivo per",
    about_eyebrow: "L'Azienda",
    about_title: "Quindici anni di infissi, vetro e passione.",
    about_p1: "Arte & Infissi è presente sul mercato italiano da oltre 15 anni. Dal 2010 produciamo infissi su misura per ogni esigenza, in alluminio, alluminio/legno e PVC, vetrate panoramiche e pergotende. Grazie a importanti investimenti in produzione e sviluppo garantiamo qualità senza compromessi, innovazione e un servizio eccellente.",
    about_p2: "Un nuovissimo impianto per finestre in PVC ad altissimo isolamento termico e acustico completa la nostra offerta. Eseguiamo sostituzioni di infissi per case in ristrutturazione e forniture complete per palazzine private in costruzione. È così che abbiamo conquistato la fiducia di oltre 2000 clienti soddisfatti.",
    about_services_eyebrow: "I nostri servizi",
    about_s1_title: "Produciamo infissi su misura per ogni esigenza",
    about_s1_text: "Dal 2010 produciamo infissi su misura in alluminio, alluminio/legno e PVC, vetrate panoramiche e pergotende.",
    about_s2_title: "Un nuovissimo impianto per finestre in PVC",
    about_s2_text: "Un impianto di ultima generazione per finestre in PVC ad altissimo isolamento termico ed acustico completa l'offerta di prodotti che realizziamo con passione.",
    about_s3_title: "Sostituzione e forniture complete",
    about_s3_text: "Eseguiamo lavori di sostituzione di infissi per case in ristrutturazione e forniture per palazzine private in costruzione.",
    contact_eyebrow: "Contatti",
    contact_title: "Vieni a trovarci. Tocca la qualità.",
    contact_sub: "Il nostro showroom e lo stabilimento di produzione sono a Cerveteri, sulla via Aurelia. Scrivici su WhatsApp per un preventivo gratuito o un rilievo in cantiere.",
    contact_hq_label: "Sede legale",
    contact_factory_label: "Produzione & Showroom",
    contact_hours_label: "Orari",
    contact_hours: "Lun – Ven: 08:30 – 13:00 / 15:00 – 18:30 · Sab su appuntamento",
    contact_phone_label: "Telefono / WhatsApp",
    contact_email_label: "Email",
    contact_social_label: "Social",
    contact_whatsapp_cta: "Chiedi un preventivo su WhatsApp",
    footer_tagline: "Infissi su misura in alluminio, alluminio/legno e PVC. Vetrate panoramiche e pergotende. Cerveteri, Roma.",
    footer_rights: "Tutti i diritti riservati.",
    footer_products: "Prodotti",
    footer_nav: "Esplora",
    footer_contact: "Contatti",
    footer_claim: "Lavorare con passione, dal 2010.",
    whatsapp_label: "Scrivici su WhatsApp",
  },
  en: {
    nav_products: "Products",
    nav_railings: "Glass Balustrades",
    filter_railings: "Glass Balustrades",
    nav_projects: "Projects",
    nav_about: "Company",
    nav_contact: "Contact",
    nav_admin: "Private Area",
    nav_quote: "Get a quote",
    hero_eyebrow: "Arte & Infissi — Cerveteri, Rome · Since 2010",
    hero_line1: "The boundary",
    hero_line2: "between inside and outside",
    hero_line3: "no longer exists.",
    hero_sub: "Aluminium, aluminium/wood and PVC windows, panoramic glass walls and pergolas. Designed, manufactured and installed to measure for your home or business.",
    hero_cta_projects: "Explore the Projects",
    hero_cta_contact: "Request a Quote",
    scroll_hint: "Scroll",
    intro_eyebrow: "About us",
    intro_title: "Since 2010 we have manufactured bespoke windows for every need. Over 2000 clients have trusted us with the light of their homes.",
    products_eyebrow: "Products",
    products_title: "Four systems, one standard of quality",
    products_sub: "From modern design to high insulation performance: selected materials that guarantee durability, efficiency and style.",
    products_all: "All products",
    product_discover: "Discover",
    featured_eyebrow: "Works",
    featured_title: "Featured projects",
    view_all: "View all projects",
    ba_eyebrow: "Before / After",
    ba_title: "The same space. A new life.",
    ba_sub: "Drag the handle to see how a panoramic glass wall turns a balcony or veranda into a room you can live in all year round.",
    ba_before: "Before",
    ba_after: "After",
    ba_view_project: "View the project",
    stats_eyebrow: "In numbers",
    stats_clients: "Satisfied clients",
    stats_years: "Years of experience",
    stats_since: "Founded",
    stats_bespoke: "Made to measure",
    manifesto_eyebrow: "Why choose us",
    manifesto_title: "Four reasons to rely on our experience",
    contact_band_eyebrow: "Let's talk",
    contact_band_title: "You can rely on our experience for your projects.",
    contact_band_cta: "Message us on WhatsApp",
    contact_band_cta2: "Go to contacts",
    projects_eyebrow: "Portfolio",
    projects_title: "Works & Realisations",
    projects_sub: "A selection of glass walls, pergolas, windows and enclosures made to measure for private homes and businesses around Rome.",
    filter_all: "All",
    filter_windows: "Windows",
    filter_doors: "Doors",
    filter_facades: "Facades",
    filter_outdoor: "Glass Rooms & Pergolas",
    filter_awnings: "Awnings",
    filter_corten: "Cor-Ten & Bronze",
    empty_title: "The portfolio is being prepared",
    empty_sub: "New works will be published shortly.",
    back_to_projects: "Back to projects",
    label_location: "Location",
    label_year: "Year",
    label_architect: "Design",
    label_dimensions: "Dimensions",
    label_materials: "Materials",
    specs_title: "Technical Performance",
    downloads_title: "Technical Documentation",
    downloads_sub: "Spec sheets, executive DWG details and material data for your studio.",
    downloads_placeholder_title: "Technical documentation coming soon",
    downloads_placeholder_sub: "PDF spec sheets and DWG details for this project will be available for download shortly. In the meantime you can request them directly.",
    downloads_placeholder_cta: "Request the spec sheet",
    gallery_title: "Gallery",
    next_project: "Next project",
    download: "Download",
    gate_title: "Technical Documentation",
    gate_sub: "Leave your professional details to download the requested file.",
    gate_name: "Full name",
    gate_firm: "Studio / Firm",
    gate_email: "Professional email",
    gate_submit: "Download file",
    gate_note: "No newsletter. Only the file you requested.",
    gate_success: "Download started. Thank you.",
    product_intro_eyebrow: "The system",
    product_benefits_eyebrow: "Benefits",
    product_variants_eyebrow: "Solutions",
    product_specs_eyebrow: "Spec sheet",
    product_specs_note: "Indicative values. The official spec sheet will be available for download.",
    product_datasheet_title: "PDF spec sheet coming soon",
    product_datasheet_sub: "The complete technical documentation for this system will be uploaded shortly. Request it now on WhatsApp.",
    product_related: "Works using this system",
    product_cta: "Request a quote for",
    about_eyebrow: "The Company",
    about_title: "Fifteen years of windows, glass and passion.",
    about_p1: "Arte & Infissi has been on the Italian market for over 15 years. Since 2010 we have manufactured bespoke windows for every need, in aluminium, aluminium/wood and PVC, plus panoramic glass walls and pergolas. Thanks to major investments in production and development we guarantee uncompromising quality, innovation and excellent service.",
    about_p2: "A brand-new plant for PVC windows with very high thermal and acoustic insulation completes our range. We replace windows in renovations and supply complete packages for private buildings under construction. This is how we earned the trust of over 2000 satisfied clients.",
    about_services_eyebrow: "Our services",
    about_s1_title: "Bespoke windows for every need",
    about_s1_text: "Since 2010 we have produced made-to-measure frames in aluminium, aluminium/wood and PVC, panoramic glass walls and pergolas.",
    about_s2_title: "A brand-new PVC window plant",
    about_s2_text: "A latest-generation plant for PVC windows with very high thermal and acoustic insulation completes the range of products we make with passion.",
    about_s3_title: "Replacements and complete supplies",
    about_s3_text: "We replace windows in homes under renovation and supply private residential buildings under construction.",
    contact_eyebrow: "Contact",
    contact_title: "Come and see us. Touch the quality.",
    contact_sub: "Our showroom and production plant are in Cerveteri, on the Via Aurelia. Message us on WhatsApp for a free quote or an on-site survey.",
    contact_hq_label: "Registered office",
    contact_factory_label: "Production & Showroom",
    contact_hours_label: "Hours",
    contact_hours: "Mon – Fri: 08:30 – 13:00 / 15:00 – 18:30 · Sat by appointment",
    contact_phone_label: "Phone / WhatsApp",
    contact_email_label: "Email",
    contact_social_label: "Social",
    contact_whatsapp_cta: "Ask for a quote on WhatsApp",
    footer_tagline: "Bespoke windows in aluminium, aluminium/wood and PVC. Panoramic glass walls and pergolas. Cerveteri, Rome.",
    footer_rights: "All rights reserved.",
    footer_products: "Products",
    footer_nav: "Explore",
    footer_contact: "Contact",
    footer_claim: "Working with passion, since 2010.",
    whatsapp_label: "Message us on WhatsApp",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ai_lang") || "it");
  useEffect(() => {
    localStorage.setItem("ai_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = { lang, setLang, t: translations[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
